<template>
	<div class="create-task-container pb-4" @click="close_selection += 1">
		<v-alert v-if="error_msg.length !== 0" type="error" class="mx-3 mt-3">{{ error_msg }}</v-alert>
		<v-alert v-if="warning_msg.length !== 0" type="warning" class="mx-3 mt-3">{{ warning_msg }}</v-alert>
		<ProgressGetDataLinear v-if="loading"/>
		<template v-if="!loading">
			<v-row class="ma-0 px-6">
				<v-col class="pb-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-0 pr-2'" :cols="$vuetify.breakpoint.xsOnly ? 12 : 7">
					<v-row class="ma-0">
						<v-col class="px-0" cols="12">
							<div class="task-title">
								<div class="leave-item-title">Leave type</div>
							</div>
							<v-select
								v-model="event_type"
								:color="color"
								:items="event_types"
								:error="error_type_flag"
								item-text="desc"
								item-value="id"
								item-color="success"
								hide-details
								return-object
								outlined
								dense
								background-color="#FAFAFA"
								@change="onLeaveTypeChange(event_type)"
							/>
						</v-col>
					</v-row>
					<v-row class="ma-0">
						<v-col class="px-0" cols="12">
							<div class="task-title">
								<div class="leave-item-title">Leave Description</div>
							</div>
							<v-text-field
								v-model="description"
								:color="color"
								:error="error_desc_flag"
								outlined
								dense
								background-color="#FAFAFA"
								hide-details
								@change="checkErrorFlag('onDescChange')"
							/>
						</v-col>
					</v-row>
					<v-row class="mx-0 mb-0 mt-3" justify="space-between" align="start" no-gutters>
						<div style="width: 74%">
							<template v-if="isAllday">
								<div class="task-title">
									<div class="leave-item-title">Start date to End date</div>
								</div>
								<DateMulti
									:suggestionText="$vuetify.breakpoint.smAndDown ? `eg, 12/3/2022-13/3/2022`:`eg, 120322-130322 or 12/3/2022-13/3/2022`"
									:color="color"
									:background="`#FAFAFA`"
									:dateStartInit="start_date_init"
									:dateEndInit="end_date_init"
									:error="error_start_date_flag || error_end_date_flag"
									@dateRange="onDateRangeChange($event)"
								/>
							</template>
							<template v-if="!isAllday">
								<div class="task-title">
									<div class="leave-item-title">Date</div>
								</div>
								<DatePicker
									style="width:100%"
									:suggestionText="`eg, 120322 or 12/3/2022`"
									:error="error_date_flag"
									:color="color"
									:isOutlined="true"
									:isIcon="true"
									:dateInit="start_date_init"
									@date="onDateChange($event)"
								/>
							</template>
						</div>
						<v-checkbox
							class="mt-6"
							v-model="isAllday"
							:color="color"
							dense
							hide-details
						>
							<template v-slot:label>
								<div class="leave-item-title">All day</div>
							</template>
						</v-checkbox>
					</v-row>
					<v-row v-if="!isAllday" class="mx-0 mb-0 mt-2">
						<DateTime
							:color="color"
							:startError="start_time_error"
							:errorStartFlag="error_start_time_flag"
							:endError="end_time_error"
							:errorEndFlag="error_end_time_flag"
							:styleLeft="`pl-0 pt-0`"
							:styleRight="`pr-0 pt-0`"
							@time_start="onTimeStartChange($event)"
							@time_end="onTimeEndChange($event)"
						/>
					</v-row>
					<v-row class="ma-0">
						<v-col class="px-0" cols="12">
							<div class="task-title">
								<div class="leave-item-title">Send approval request to</div>
							</div>
							<v-autocomplete
								v-model="leave_approval_by"
								:color="color"
								:disabled="leave_approval_disabled"
								:items="leave_approval_by_items"
								item-color="success"
								item-text="desc"
								item-value="id"
								background-color="#FAFAFA"
								return-object
								hide-details
								outlined
								dense
								@change="checkErrorFlag('all')"
							/>
						</v-col>
					</v-row>
				</v-col>
				<v-col class="pb-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-2 pr-0'"  :cols="$vuetify.breakpoint.xsOnly ? 12 : 5">
					<v-row class="mt-3 mx-0 mb-0" style="height: 100%">
						<v-divider v-if="!$vuetify.breakpoint.xsOnly" vertical color="#D9D9D9"/>
						<div class="column-container" style="width: 100%">
							<div class="leave-item-title" :class="$vuetify.breakpoint.xsOnly ? '':'px-2'" :style="isRestricted ? 'opacity: 0.4':''">Leave for</div>
							<div class="column-container" :class="!$vuetify.breakpoint.xsOnly ? 'pl-2':''">
								<InviteesTreeSelection
									v-if="can_invitemultiple"
									:color="color"
									:bgColor="'#FAFAFA'"
									:selected="select_invitees"
									:closeSelection="close_selection"
									:error="error_invitee_flag"
									:disabled="isRestricted"
									@assign-selected="onInviteeSelected($event)"
								/>
								<v-select
									v-if="!can_invitemultiple"
									v-model="leave_for"
									:loading="loading_leave_for"
									:items="leave_for_items"
									:color="color"
									:menu-props="{ bottom: true, offsetY: true}"
									:error="error_invitee_flag"
									:disabled="isRestricted"
									append-icon=""
									background-color="#FAFAFA"
									item-text="name"
									item-value="id"
									item-color="success"
									outlined
									dense
									hide-details
									return-object
									@change="onLeaveForChange($event)"
								>
									<template v-slot:item="{item, on, attrs}">
										<v-checkbox
											class="mt-0 pt-0"
											v-on="on"
											:value="attrs.inputValue"
											:ripple="false"
											:color="color"
											dense
											hide-details
										>
											<template v-slot:label>
												<span>
													{{ item.name }}
													<v-chip v-if="item.freelancer" color="info" x-small class="ml-1">Freelancer</v-chip>
												</span>
											</template>
										</v-checkbox>
									</template>
								</v-select>
							</div>
							<div v-if="inviteesFilter.length > 1" class="leave-item-title ml-2" style="font-size: 12px; color: #EE0202;">{{ warning }}</div>
							<div class="leave-item-title ml-2" :class="inviteesFilter.length <= 1 ? 'mt-3':''" :style="isRestricted ? 'opacity: 0.4':''">Select invitees below to email:</div>
							<div class="ml-2 mb-2">
								<v-checkbox
									v-model="email"
									:color="color"
									:disabled="isRestricted"
									dense
									hide-details
									@change="onSelectAllEmailChange()">
									<template v-slot:label>
										<span class="leave-item-title" :style="isRestricted ? 'opacity: 0.4':''">Select all</span>
									</template>
								</v-checkbox>
							</div>
							<div style="height: 338px">
								<v-virtual-scroll
									:items="inviteesFilter"
									:height="$vuetify.breakpoint.xsOnly ? 100:330"
									item-height="48"
								>
									<template v-slot:default="{ item }">
										<div class="task-title pl-2">
											<div>
												<v-checkbox
													class="mt-0 pt-0"
													v-model="item.employee.send_email"
													:color="color"
													dense
													hide-details
													@change="onEmailChange()">
													<template v-slot:label>
														<div class="task-top over-background" style="justify-content: flex-start">
															<div class="mr-1">
																<v-user-avatar
																	size="24"
																	class="text-caption text-decoration-none"
																	:code="item.employee.display_name"
																	:image="`/api/addressbook/${item.employee.id}/image.png`"
																/>
															</div>
															<div class="column-container">
																<div class="item-text over-text" style="color: #192A3E">{{ item.employee.display_name }}</div>
																<div v-if="item.employee.email.length !== 0" class="item-text over-text" style="color: rgba(25, 42, 62, 0.7); font-size: 12px; width: 148px;">{{ item.employee.email }}</div>
															</div>
														</div>
													</template>
												</v-checkbox>
											</div>
											<div>
												<v-btn icon color="rgba(25, 42, 62, 0.5)" @click.stop="onRemoveInvitee(item.id)">
													<v-icon>mdi-close</v-icon>
												</v-btn>
											</div>
										</div>
									</template>
								</v-virtual-scroll>
							</div>
						</div>
					</v-row>
				</v-col>
			</v-row>
		</template>
		<v-row v-if="!loading" class="ma-0 px-6" justify="space-between">
			<v-checkbox
				v-model="mark_approved"
				label="Approved"
				color="info"
				:disabled="!approvePrivilege"
				dense
				hide-details
				@change="onMarkCompleteChange($event)">
			</v-checkbox>
			<v-row class="ma-0" justify="end">
				<v-btn
					class="text-capitalize mr-2"
					color="#757575"
					text
					@click="$emit('close')"  
				>
					Cancel
				</v-btn>
				<v-btn 
					class="white--text text-capitalize"
					color="#00AAFD" 
					@click="onCreate()"  
					:disabled="!isActive"
				>
					Create Leave
				</v-btn>
			</v-row>
		</v-row>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
			:color="notice_color"
		/>
	</div>
</template>

<script>
import DateMulti from "@/components/date/date_multi.vue";
import DatePicker from "@/components/date/date_picker.vue";
import DateTime from "@/components/date/date_time.vue";
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import InviteesTreeSelection from "@/views/events/invitees_tree_selection.vue";

import { validTime } from "@/common/validTime.js";
import config from "@/config.js";
import moment from 'moment-timezone';

const DescriptionLimit = 60;
const ALLEMPLOYEES = 2;

const Employee_Key = 'Employee';
const Freelancer_key = 'Freelancer';

/** 0-invited, 1-accepted, 2-rejected */
const Invited_Code = 0;

/** If selected the user can manage and approve leave events */
const DAppLeave = 'DAppLeave';

/** license_type, 2 = 'ATS user', 3 = 'ATS+ user' */
const ATS = 'ATS';

const Warning = 'This will create 1 leave event for each person. Once created, bulk editing is not available.';

export default {
	name: 'NewLeave',
	props: {
		leaveId: {
			type: Number,
			default: 0,
		},
		leaveType: {
			type: Object,
			default: null,
		},
		startDate: {
			type: String,
			default: '',
		},
		endDate: {
			type: String,
			default: '',
		},
		partialLeave: {
			type: Boolean,
			default: false,
		},
		partDate: {
			type: String,
			default: '',
		},
		startTime: {
			type: String,
			default: '',
		},
		endTime: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: '',
		}
	},
	components: {
		DateMulti,
		DatePicker,
		ProgressGetDataLinear,
		DialogNotice,
		InviteesTreeSelection,
		DateTime
	},
	data() {
		this.warning = Warning;

		return {
			loading: true,
			loading_leave_for: false,
			timezone_loading: false,

			error_msg: '',
			warning_msg: '',
			close_selection: 0,
			privileges: [],

			event_type: null,
			event_types: [],
			description: '',

			isAllday: true,
			date_range: [],
			start_date_init: '',
			end_date_init: '',
			start_date: '',
			end_date: '',

			start_time: '',
			end_time: '',
			start_time_error: false,
			end_time_error: false,

			user_timezone: '',
			timezone_items: [],
			timezone: null,

			leave_approval_by: { id: 0, desc: 'Do not send' },
			leave_approval_by_items: [{ id: 0, desc: 'Do not send' }],
			leave_approval_disabled: false,
			mark_approved: false,

			select_invitees: [],
			leave_for: null,
			leave_for_items: [],
			can_invitemultiple: false,
			email: false,

			error_type_flag: false,
			error_desc_flag: false,
			error_start_date_flag: false,
			error_end_date_flag: false,
			error_date_flag: false,
			error_start_time_flag: false,
			error_end_time_flag: false,
			error_invitee_flag: false,
			button_click_flag: false,

			visible_notice: false,
			notice_text: [],
			tid: null,
			notice_color: '#00AAFD',
		}
	},
	async created() {
		if (this.$store.state.privileges && this.$store.state.privileges.length === 0) {
			this.initPrivileges();
		} else {
			this.privileges = this.$store.state.privileges;
		}
		
		this.getEventTypeList();
		this.getApprovalBy();
		this.getUserTimezone();
		this.getTimezone();
	},
	computed: {
		user_type() {
			let user_type = 0;

			if (this.$store.state.user) {
				user_type = this.$store.state.user.license_type;
			}		

			return user_type;
		},
		from_other() {
			let is_from_other =  false;

			if (this.$route.params.current_tab) {
				is_from_other = true;
			}

			return is_from_other;
		},
		approvePrivilege() {
			let isApprovePrivilegeTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(DAppLeave)) {				
				isApprovePrivilegeTmp = true;
			}
			return isApprovePrivilegeTmp;
		},
		user_abid() {
			let abid = 0;
			const user = this.$store.state.user;

			if (user && user.addressbook) {
				abid = user.addressbook.id;
			}		

			return abid;
		},
		inviteesFilter() {
			let invitees_list = [];

			if (this.select_invitees.length !== 0) {
				const obj_tmp = {};
				this.select_invitees.forEach(d => {
					if (!obj_tmp[d.employee.id]) {
						invitees_list.push(d);
						obj_tmp[d.employee.id] = true;
					}
				});
			}

			return invitees_list;
		},
		isActive() {
			let is_active = false;

			if (this.event_type && this.description.length !== 0 && (this.isRestricted ? this.select_invitees.length === 0 : this.select_invitees.length !== 0)  && this.start_date && this.start_date.length !== 0 && this.end_date && this.end_date.length !== 0) {
				if (!this.isAllday) {
					const start_24_hour = this.start_time ? moment(this.start_time, 'h:mm a').format('HH:mm') : '';
					const end_24_hour = this.end_time ? moment(this.end_time, 'h:mm a').format('HH:mm') : '';

					if (start_24_hour.length !== 0 && end_24_hour.length !== 0 && start_24_hour < end_24_hour) {
						is_active = true;
					}
				}

				if (this.isAllday && this.start_date <= this.end_date) {
					is_active = true;
				}
			}

			return is_active;
		},
		time_required() {
			let is_required = false;

			if (this.start_date && this.start_date.length !== 0 && this.end_date && this.end_date.length !== 0 && this.start_date === this.end_date) {
				if (this.start_time && this.start_time.length !== 0 && !this.end_time) {
					is_required = true;
				}
			}
			return is_required;
		},
		isRestricted() {
			let isRestricted = false;

			if (this.user_type.includes(ATS)) {
				isRestricted = true;
			}
			
			return isRestricted;
		}	
	},
	methods:{
		async initPrivileges() {
			this.loading = true;
			
			const url = "/api/user/me/privileges";

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}					
				})
				.then(val => {
					const {status, data}  = val.data;

					if (status === "OK") {
						this.privileges = data;
					}
				})
				.catch((e) => {
					console.log(e.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getEventTypeList() {
			const url = '/api/events/meta';

			axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const leave_order = ['annual leave', 'personal leave', 'unpaid leave', 'long service leave'];

						const order_leave_arr = [];
						leave_order.forEach(leave => {
							const arr = data.event_types.filter(e => { return e.desc.toLowerCase() === leave })
							order_leave_arr.push(arr[0])
						});

						const unorder_leave_arr = data.event_types.filter(type => { return !leave_order.includes(type.desc.toLowerCase())})

						this.event_types = [...order_leave_arr, ...unorder_leave_arr];
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				})
		},
		getApprovalBy() {
			let url = '/api/tasks/list_assignees';

			const params = [];
			// 3 = "Employees", 12 = 'Freelancers', from 'api/addressbook/meta'
			params.push("abook_types=" + encodeURIComponent("3, 12"));
			params.push("has_privilege=" + DAppLeave);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const approval_by = data[0].employees;
						approval_by.forEach(a => { a['desc'] = this._formatName(a.display_name) });
						approval_by.unshift(this.leave_approval_by);

						this.leave_approval_by_items = approval_by;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getUserTimezone() {
			const url = '/api/user/me/timezone';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_timezone = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getTimezone() {
			this.timezone_loading = true;

			const url = '/api/support/timezones';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const timezone_group = {};

						const data_filter = data.filter(d => {
							const time_zone_key = d.value.toUpperCase();
							return !time_zone_key.includes(config.time_zone_keys[0]) && !time_zone_key.includes(config.time_zone_keys[1]);
						});
						data_filter.forEach(timezone => {
							const group_key = (timezone.value.split('/'))[0];
							const group_key_arr = Object.keys(timezone_group);

							if (group_key_arr.includes(group_key)) {
								const arr = timezone_group[`${group_key}`];

								const child = {
									key: timezone.value,
									name: `${(timezone.description.split(' '))[0]} (GMT${(timezone.description.split(' '))[1]})`,
									is_default: timezone.is_default,
									children: 0
								}

								timezone_group[`${group_key}`] = [...arr, child];
							} else {
								const child = {
									key: timezone.value,
									name: `${(timezone.description.split(' '))[0]} (GMT${(timezone.description.split(' '))[1]})`,
									is_default: timezone.is_default,
									children: 0
								}
								timezone_group[`${group_key}`] = [child];
							}
						});

						let timezone_list = [];
						for (const [key, value] of Object.entries(timezone_group)) {
							const node = {
								key: `parent_${key}`,
								name: key,
								is_default: false,
								children: value.length
							}
							timezone_list= [...timezone_list, node, ...value];
						}
						this.timezone_items = timezone_list;

						const default_timezone_arr = timezone_list.filter(timezone => { return timezone.is_default === true});
						this.timezone = default_timezone_arr.length !== 0 ? default_timezone_arr[0] : null;

					} else {
						this.error_msg = reason;
						this.timezone_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.timezone_loading = false;
				})
				.finally(() => {
					this.timezone_loading = false;
				})
		},
		getInviteesList() {
			this.loading_leave_for = true;

			const params = [];
			params.push("allow_all=" + false);
			params.push("find_employee=" + true);
			params.push("find_freelancer=" + true);

			let url = "/api/addressbook/email";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						const all_filter = data.filter(d => { return d.contact_id === null && d.abook_id !== null });
						const employees_filter = data.filter(d => { return d.contact_id === null && d.abook_id !== null && d.info === Employee_Key });
						const employee_ids = employees_filter.map(e => { return e.abook_id });
						all_filter.forEach(e => {
							if (e.info === Freelancer_key && !employee_ids.includes(e.abook_id)) {
								e['is_freelancer'] = true;
							} else {
								e['is_freelancer'] = false;
							}
						});
						this.leave_for_items = this.getAllEmployees(all_filter);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading_leave_for = false;
				});
		},
		getAllEmployees(data) {
			const unique = [];
			const obj_tmp = {};

			data.forEach(d => {
				if (!obj_tmp[d.abook_id]) {
					unique.push(d);
					obj_tmp[d.abook_id] = true;
				}
			});

			const employees_all = [];
			unique.forEach(d => {
				const name = this._formatName(d.display_name);
				const description = name.length > DescriptionLimit
					? name.slice(0, DescriptionLimit) + '...'
					: name;

				const obj = {
					id: `${ALLEMPLOYEES}_${d.abook_id}`,
					name: description,
					type: ALLEMPLOYEES,
					accepted: Invited_Code,
					contact: null,
					freelancer: d.is_freelancer,
					employee: {
						id: d.abook_id,
						contact_id: null,
						code: d.code,
						display_name: description,
						email: d.email,
						send_email: true
					},
					image: `${d.uri}/image.png`,
					uri: d.uri
				};
				
				employees_all.push(obj);
			});		

			return employees_all;
		},
		onLeaveTypeChange(event_type) {
			this.checkErrorFlag('onDescChange');

			const url = `/api/config/eventtype/${event_type.id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.can_invitemultiple = data.can_invitemultiple;
						if (!this.can_invitemultiple && this.select_invitees.length > 1) {
							this.select_invitees = [];
						}

						if (this.can_invitemultiple && this.select_invitees.length <= 1) {
							this.leave_for = null;
						}

						if (!this.can_invitemultiple) {
							this.getInviteesList();
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading_leave_for = false;
				});
		},
		onLeaveForChange(leave_for) {
			this.select_invitees = [];
			this.select_invitees.push(leave_for);
			this.email = true;

			this.checkErrorFlag('all');
		},
		onInviteeSelected(invitees) {
			this.select_invitees = invitees;
			
			this.onEmailChange();
			this.checkErrorFlag('all');
		},
		onSelectAllEmailChange() {
			this.onAllEmailChange();
			this.checkErrorFlag('all');
		},
		onAllEmailChange() {
			if (this.email) {
				this.select_invitees.forEach(invite => {
					invite.employee.send_email = true;
				});
			} else {
				this.select_invitees.forEach(invite => {
					invite.employee.send_email = false;
				});
			}
		},
		onEmailChange() {
			this.checkErrorFlag('all');
			
			const is_all_selected = this.select_invitees.length === 0  ? false : this.select_invitees.every(invite => { return invite.employee.send_email === true });

			if (is_all_selected) {
				this.email = true;
			} else {
				this.email = false;
			}
		},
		onRemoveInvitee(id) {
			const e_id = Number((id.split('_'))[1]);
			this.select_invitees = this.select_invitees.filter(invitee => { return invitee.employee.id !== e_id });
			
			if (this.select_invitees.length === 0) {
				this.email = false;
				this.leave_for = null;
			}
			this.checkErrorFlag('all');
		},
		onMarkCompleteChange(is_approved) {
			if (is_approved) {
				this.leave_approval_by = { id: 0, desc: 'Do not send' };
				this.leave_approval_disabled = true;
			} else {
				this.leave_approval_disabled = false;
			}
			this.checkErrorFlag('all');
		},
		onDateRangeChange(value) {
			this.checkErrorFlag('onDateRangeChange');

			this.error_msg = '';
			this.warning_msg = '';

			if (value.length === 0) {
				this.start_date_init = '';
				this.end_date_init = '';

				this.start_date = '';
				this.end_date = '';
			}

			if (value.length === 2) {
				this.start_date_init = value[0];
				this.end_date_init = value[1];

				this.start_date = value[0];
				this.end_date = value[1];
			}
			
			if (this.isActive) {
				this._date_check();
			}
		},
		onEndDateChange(value) {
			this.end_date_init = value ? value : '';
			this.end_date = value ? value : '';

			if (this.isActive) {
				this._date_check();
			}
		},
		onDateChange(value) {
			this.checkErrorFlag('onDateChange');

			this.start_date_init = value ? value : '';
			this.end_date_init = value ? value : '';

			this.start_date = value ? value : '';
			this.end_date = value ? value : '';

			if (this.isActive) {
				this._date_check();
			}
		},
		onTimeStartChange(time) {
			this.checkErrorFlag('onTimeChange');

			this.error_msg = '';
			this.warning_msg = '';
			this.start_time_error = false;
			this.end_time_error = false;
			
			this.start_time = time;

			this._timeCheck(true);
		},
		onTimeEndChange(time) {
			this.checkErrorFlag('onTimeChange');

			this.error_msg = '';
			this.warning_msg = '';
			this.start_time_error = false;
			this.end_time_error = false;

			this.end_time = time;

			this._timeCheck(false);
		},
		onCreate(){
			if (this.button_click_flag) return;
			
			this.button_click_flag = true;

			/** timezone conversion */
			const start_date_tmp = this.isAllday?
				moment(`${this.start_date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
				: moment(`${this.start_date} ${this.start_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');

			const end_date_tmp = this.isAllday ?
				moment(`${this.end_date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
				: moment(`${this.start_date} ${this.end_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');

			moment.tz.setDefault(this.timezone.key);
			const timezone_start_date = moment(start_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
			const timezone_end_date = moment(end_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
			moment.tz.setDefault(this.user_timezone);

			const start_date = moment(timezone_start_date).utc().format('YYYY-MM-DD HH:mm:ss Z');
			const end_date = moment(timezone_end_date).utc().format('YYYY-MM-DD HH:mm:ss Z');

			
			const unique = [];
			const obj_tmp = {};
			this.select_invitees.forEach(d => {
				if (!obj_tmp[d.employee.id]) {
					unique.push(d);
					obj_tmp[d.employee.id] = true;
				}
			});
			
			const invitees = []; 
			unique.forEach(i => {
				const invitee_obj = {
					id: 0,
					accepted: Invited_Code,
					is_deleted: false,
					pay_processed: false,
					send_email: i.employee.send_email,
					email_id: i.employee.email,
					is_organiser: i.employee.id === this.user_abid ? true : false
				};

				if (i.employee.contact_id) {
					invitee_obj['contact_id'] = i.employee.contact_id;
				} else {
					invitee_obj['employee_id'] = i.employee.id;
				}

				invitees.push(invitee_obj);
			});
			

			const params = {
				event_type_id: this.event_type.id,
				description: this.description,
				all_day: this.isAllday,
				start_date: start_date,
				end_date: end_date,
				duration: 0,
				timezone: this.user_timezone
			};

			if (invitees.length !== 0) {
				params['invitees'] = invitees;
			}

			if (this.leave_approval_by && this.leave_approval_by.id !== 0) {
				params['approval_by'] = this.leave_approval_by.id;
			}

			if (this.approvePrivilege && this.mark_approved) {
				params['is_approved'] = this.mark_approved;
			} else {
				params['is_approved'] = false;
			}

			this._createLeave(params);
			
		},		
		checkErrorFlag(key) {
			this.error_type_flag = false;
			this.error_desc_flag = false;
			this.error_start_date_flag = false;
			this.error_end_date_flag = false;
			this.error_date_flag = false;
			this.error_start_time_flag = false;
			this.error_end_time_flag = false;
			this.error_invitee_flag = false;

			if (key === 'onDescChange') {
				if (!this.event_type) {
					this.error_type_flag = true;
				}
			}

			if (key === 'onDateRangeChange') {
				if (!this.event_type) {
					this.error_type_flag = true;
				}
				if (this.description.length === 0) {
					this.error_desc_flag = true;
				}
			}

			if (key === 'onDateChange') {
				if (!this.event_type) {
					this.error_type_flag = true;
				}
				if (this.description.length === 0) {
					this.error_desc_flag = true;
				}
			}

			if (key === 'onTimeChange') {
				if (!this.event_type) {
					this.error_type_flag = true;
				}
				if (this.description.length === 0) {
					this.error_desc_flag = true;
				}
				if (this.start_date.length === 0 || this.end_date.length === 0) {
					this.error_date_flag = true;
				}
			}

			if (key === 'all') {
				if (!this.event_type) {
					this.error_type_flag = true;
				}
				if (this.description.length === 0) {
					this.error_desc_flag = true;
				}
				if (this.isAllday) {
					if (this.start_date.length === 0 || this.end_date.length === 0) {
						this.error_start_date_flag = true;
						this.error_end_date_flag = true;
					}
				} else {
					if (this.start_date.length === 0 || this.end_date.length === 0) {
						this.error_date_flag = true;
					}
					if (this.start_time.length === 0) {
						this.error_start_time_flag = true;
					}
					if (this.end_time.length === 0) {
						this.error_end_time_flag = false;
					}
				}
				if (this.select_invitees.length === 0) {
					this.error_invitee_flag = true;
				}
			}
		},
		_createLeave(params) {
			const url = "/api/leave";

			axios
				.post(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Leave has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		_formatName(name) {
			let display_name = '';

			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		_date_check() {
			this.error_msg = '';
			this.warning_msg = '';

			const start_date = moment(this.start_date).format('YYYYMMDD');
			const end_date = this.end_date ? moment(this.end_date).format('YYYYMMDD') : '';

			const params = [];

			const user = this.$store.state.user;
			params.push("employees=" + user.addressbook.id);

			if (start_date.length !== 0) {
				params.push('start_date='+ start_date);
			}

			if (end_date.length !== 0) {
				params.push('end_date='+ end_date);
			}
			
			params.push("event_types=" + [2,3,4,5,6]);

			let url = "/api/leave";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						let exist_leaves = 0;

						exist_leaves = data.length;

						if (exist_leaves > 0) {
							this.warning_msg = 'A leave request already exists for the selected date';
						}							
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_timeCheck(is_start){
			const time_start = this.start_time ? this.start_time: '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.end_time ? this.end_time : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
				const time1 = moment(this.start_time, 'h:mm a');
				const time2 = moment(this.end_time, 'h:mm a');
				const budget = time2.diff(time1, 'minutes');
				
				if (budget < 0) {
					if (is_start) {
						this.start_time_error = true;
					} else {
						this.end_time_error = true;
					}
				} 
			}
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
			this.$emit('close');
		}
	}
}

</script>
<style lang="scss" scoped>
.top-line {
  width: 100%;
  height: 4px;
  background: #FFB946;
  border-radius: 4px 4px 0px 0px;
}

.leave-content {
	background-color:#FFFFFF;
	border-radius: 4px;
	max-width: 750px;
	min-height:100%;
}

.leave-content-desktop {
	background: #FFFFFF;
  border-radius: 4px;
  max-width: 100%;
	min-height:100%;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.leave-item-title {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(55, 73, 95, 1);
}

.leave-item-title-disable {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(55, 73, 95, 1);
	opacity: 0.5;
}
.task-top {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}
.over-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.over-background {
	&:hover {
		background-color: #FAFAFA;
		border-radius: 4px;
	}
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.paid-button {
	width: 64px;
	height: 36px;
	background-color: rgb(193, 128, 20);
	border-color: rgb(193, 128, 20);
	color:#FFFFFF;
	border-radius: 4px;
	text-align: center;
	
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;

	color: #F45252;
}
.optional-text-red-keyword {
	text-decoration: underline;
	&:hover {
		cursor: pointer;
	}
}

::v-deep {
	.selection .v-select__selections {
		color: #FFFFFF;
		font-family: Roboto;
		font-size: 14px;
		font-weight: 500;
	}
	.selection .theme--light.v-icon {
		color: #FFFFFF;
	}
}
</style>
